import { useEffect } from 'react';

import { useDocumentTitle } from 'hooks/document-title';
import ReactGA from 'react-ga4';

import { Error } from './Error';

const Error500 = () => {
  useDocumentTitle('Server Error | Checkmate');

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
      title: '500 Server Error',
    });
  }, []);

  return <Error>500</Error>;
};

export default Error500;
